module.exports = __webpack_public_path__ + "img/snezana_s.80268da8.png";